export default __webpack_public_path__ + "static/media/lock-icon-active.02335f38.svg";